// Action Types
export const SET_EMAIL_INGESTION_BLOCKLIST = 'organizations/setEmailIngestionBlocklist'
export const ADD_EMAIL_INGESTION_BLOCKLIST_ENTRY = 'organizations/addEmailIngestionBlocklistEntry'
export const REMOVE_EMAIL_INGESTION_BLOCKLIST_ENTRY =
  'organizations/removeEmailIngestionBlocklistEntry'
export const SET_EMAIL_INGESTION_BLOCKLIST_LOADING =
  'organizations/setEmailIngestionBlocklistLoading'

// Action Creators
export const setEmailIngestionBlocklist = (payload) => ({
  type: SET_EMAIL_INGESTION_BLOCKLIST,
  payload,
})
export const addEmailIngestionBlocklistEntry = (payload) => ({
  type: ADD_EMAIL_INGESTION_BLOCKLIST_ENTRY,
  payload,
})
export const removeEmailIngestionBlocklistEntry = (payload) => ({
  type: REMOVE_EMAIL_INGESTION_BLOCKLIST_ENTRY,
  payload,
})
export const setEmailIngestionBlocklistLoading = (payload) => ({
  type: SET_EMAIL_INGESTION_BLOCKLIST_LOADING,
  payload,
})

// State
export const initialState = { entries: [], loading: false }

// Reducer
export default function emailIngestionBlocklistReducer(state = initialState, action) {
  switch (action.type) {
    case SET_EMAIL_INGESTION_BLOCKLIST:
      return { ...state, entries: action.payload }
    case ADD_EMAIL_INGESTION_BLOCKLIST_ENTRY:
      return { ...state, entries: [...state.entries, action.payload] }
    case REMOVE_EMAIL_INGESTION_BLOCKLIST_ENTRY:
      return {
        ...state,
        entries: state.entries.filter((entry) => entry.id !== action.payload),
      }
    case SET_EMAIL_INGESTION_BLOCKLIST_LOADING:
      return { ...state, loading: action.payload }
    default:
      return state
  }
}
